import Vue from 'vue'
import App from './App.vue'
import router from './router'
import DemoBlock from './components/demo-block.vue'
import 'element-ui/lib/theme-chalk/index.css'
import ElementUI from 'element-ui'
import ApexUI from '@/index'
import 'highlight.js/styles/atom-one-dark.css' // 代码高亮样式

import VueI18n from 'vue-i18n'
import elementEnLocale from 'element-ui/lib/locale/lang/en' // element-ui lang
import elementZhLocale from 'element-ui/lib/locale/lang/zh-CN'// element-ui lang
import elementZhTWLocale from 'element-ui/lib/locale/lang/zh-TW'// element-ui lang
import enLocale from '@/langEn'
import zhLocale from '@/langZhCN'
import zhTWLocale from '@/langZhTW'

Vue.use(VueI18n)

const messages = {
  en: {
    ...enLocale,
    ...elementEnLocale
  },
  zhCN: {
    ...zhLocale,
    ...elementZhLocale
  },
  zhTW: {
    ...zhTWLocale,
    ...elementZhTWLocale
  }
}
export function getLanguage() {
  const chooseLanguage = localStorage.getItem('language')
  if (chooseLanguage) return chooseLanguage

  // if has not choose language
  const language = (navigator.language || navigator.browserLanguage).toLowerCase()
  const locales = Object.keys(messages)
  for (const locale of locales) {
    if (language.indexOf(locale) > -1) {
      return locale
    }
  }
  return 'en'
}
const i18n = new VueI18n({
  // set locale
  // options: en | zh | es
  locale: getLanguage(),
  // set locale messages
  messages
})

Vue.component('demo-block', DemoBlock)
Vue.use(ElementUI, { size: 'medium', i18n: (key, value) => i18n.t(key, value) })
// Vue.use(ElementUI, { size: 'medium', locale: en })
Vue.use(ApexUI, { i18n: (key, value) => i18n.t(key, value) })

Vue.config.productionTip = false

new Vue({
  router,
  i18n,
  render: h => h(App)
}).$mount('#app')
